var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.932617,
    y: -0.0078125,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FF933B",
    fillOpacity: 0.06
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.43262,
    y: 0.492188,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "url(#paint0_linear_3478_4779)",
    strokeOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3478_4779)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.3303 17.2505L16.2461 17.2505L33.3303 17.2505Z",
    fill: "#FF9407"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3303 17.2505L16.2461 17.2505L33.3303 17.2505Z",
    fill: "#FF933B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3303 17.2505L16.2461 17.2505",
    stroke: "#FF9407",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3303 17.2505L16.2461 17.2505",
    stroke: "#FF933B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.8604 23.9922H13.7158H35.8604Z",
    fill: "#FF9407"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8604 23.9922H13.7158H35.8604Z",
    fill: "#FF933B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8604 23.9922H13.7158",
    stroke: "#FF9407",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8604 23.9922H13.7158",
    stroke: "#FF933B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.8601 30.4849L15.8545 30.4849",
    stroke: "#FF9407",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8601 30.4849L15.8545 30.4849",
    stroke: "#FF933B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3478_4779",
    x1: 2.481,
    y1: -0.00781267,
    x2: 56.3683,
    y2: 11.6204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "white",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.52
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3478_4779"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12.9326 11.9922)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu);
export default __webpack_public_path__ + "static/media/icon-menu.48d7cb89b4021ecb4cc0e2a3e951f1ea.svg";
export { ForwardRef as ReactComponent };